module.exports = __webpack_public_path__ + "static/media/buy_req_teach_12.c5a184fd.jpg";